import React from 'react';
export function ContentSection() {
  return <div className="prose prose-lg max-w-none" data-id="element-10">
      <div className="mb-10" data-id="element-11">
        <p className="text-gray-700" data-id="element-12">
          As you just saw, the Blue Brick isn't some flimsy plastic gadget
          that'll break after a few range sessions. This thing is solid –
          weighing in at 3 pounds of precision-engineered metal. And it's not
          gimmicky. You won't be embarrassed to pull this out at the range.
        </p>
      </div>
      <div className="mb-10" data-id="element-13">
        <h3 className="text-2xl font-semibold text-gray-800" data-id="element-14">
          Fits Right in Your Golf Bag
        </h3>
        <div className="clearfix" data-id="element-15">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fsyxDerNWTLdzSJQRtKmNh/Screenshot_2025-06-12_at_1.26.05_PM.png" alt="The Blue Brick golf training aid" className="float-left mr-6 mb-4 w-64 rounded-lg" data-id="element-16" />
          <p className="text-gray-700" style={{
          paddingBottom: '5%'
        }} data-id="element-17">
            At about the size of a box of balls, the Blue Brick travels with you
            everywhere. The included alignment sticks collapse down to 12" – so
            there's always room in your bag for better golf.
          </p>
        </div>
      </div>
      <div className="mb-10" data-id="element-18">
        <h3 className="text-2xl font-semibold text-gray-800" data-id="element-19">
          The "Swiss Army Knife" of Golf Training
        </h3>
        <p className="text-gray-700" data-id="element-20">
          While other training aids do ONE thing (and usually not very well),
          the Blue Brick gives you 11 different ways to fix your swing:
        </p>
        <ul className="mt-4 space-y-2 text-gray-700" data-id="element-21">
          <li className="flex" data-id="element-22">
            <span className="text-green-600 font-bold mr-2" data-id="element-23">✓</span>
            <span data-id="element-24">
              Shallow your downswing like the pros (the #1 difference between
              good and bad ball strikers)
            </span>
          </li>
          <li className="flex" data-id="element-25">
            <span className="text-green-600 font-bold mr-2" data-id="element-26">✓</span>
            <span data-id="element-27">Turn your slice into a draw in one practice session</span>
          </li>
          <li className="flex" data-id="element-28">
            <span className="text-green-600 font-bold mr-2" data-id="element-29">✓</span>
            <span data-id="element-30">Compress your wedges with perfect shaft lean</span>
          </li>
          <li className="flex" data-id="element-31">
            <span className="text-green-600 font-bold mr-2" data-id="element-32">✓</span>
            <span data-id="element-33">Hit it flush with ball-then-turf contact every time</span>
          </li>
          <li className="flex" data-id="element-34">
            <span className="text-green-600 font-bold mr-2" data-id="element-35">✓</span>
            <span data-id="element-36">Perfect your alignment and ball position</span>
          </li>
          <li className="flex" data-id="element-37">
            <span className="text-green-600 font-bold mr-2" data-id="element-38">✓</span>
            <span data-id="element-39">And 6 more game-changing functions...</span>
          </li>
        </ul>
      </div>
      <div className="mb-10" data-id="element-40">
        <h3 className="text-2xl font-semibold text-gray-800" data-id="element-41">
          Based on SECRET PGA Tour Data
        </h3>
        <p className="text-gray-700" data-id="element-42">
          Here's what most golfers don't know: Clay spent over a year getting
          access to classified swing data from 200+ PGA Tour players. This isn't
          guesswork – every angle on the Blue Brick is calibrated to match what
          the world's best golfers actually do.
        </p>
      </div>
      <div className="mb-10" data-id="element-43">
        <h3 className="text-2xl font-semibold text-gray-800" data-id="element-44">
          Why Golfers Are Calling It "Life-Changing"
        </h3>
        <div className="space-y-6 mt-4" data-id="element-45">
          <div className="bg-blue-50 p-4 rounded-lg border border-blue-100" data-id="element-46">
            <p className="italic text-gray-700" data-id="element-47">
              "After just two 1-hour practice sessions, I turned my drives from
              200-yard weak fades to <strong data-id="element-48">240-yard slight draws</strong>{' '}
              EVERY single time!"
            </p>
            <p className="text-gray-600 font-medium" data-id="element-49">– Greg C., 16 handicap</p>
          </div>
          <div className="bg-blue-50 p-4 rounded-lg border border-blue-100" data-id="element-50">
            <p className="italic text-gray-700" data-id="element-51">
              "Shot my <strong data-id="element-52">lowest score</strong> ever after{' '}
              <strong data-id="element-53">one range session</strong> with the Brick!"
            </p>
            <p className="text-gray-600 font-medium" data-id="element-54">– Justin B.</p>
          </div>
          <div className="bg-blue-50 p-4 rounded-lg border border-blue-100" data-id="element-55">
            <p className="italic text-gray-700" data-id="element-56">
              "Lowered my handicap from 10.2 to 8.4. I feel so comfortable over
              the ball now."
            </p>
            <p className="text-gray-600 font-medium" data-id="element-57">– Denis</p>
          </div>
          <div className="bg-blue-50 p-4 rounded-lg border border-blue-100" data-id="element-58">
            <p className="italic text-gray-700" data-id="element-59">
              "This thing is very well engineered. It's also{' '}
              <strong data-id="element-60">very well made</strong> …. your grandkids will be using
              this thing. Across my bag, I'm <strong data-id="element-61">hitting better than ever</strong>. 
              For about the price of one lesson with my pro, it's been{' '}
              <strong data-id="element-62">worth every penny</strong>. One of the few training aids
              I've purchased that really works. I'm very satisfied."
            </p>
            <p className="text-gray-600 font-medium" data-id="element-63">– John Elsy</p>
          </div>
        </div>
      </div>
      <div className="mb-10" data-id="element-64">
        <h3 className="text-2xl font-semibold text-gray-800" data-id="element-65">
          60-Day "Hit It Pure" Guarantee
        </h3>
        <div className="clearfix" data-id="element-66">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bEvbrxAiDwc8USGWLWmKxg/guarantee-1.png" alt="60 Day Money Back Guarantee Badge" className="float-left mr-6 mb-4 w-32" data-id="element-67" />
          <p className="text-gray-700" data-id="element-68">
            The Blue Brick either transforms your ball striking from driver
            through putter, or we'll refund every penny. No questions asked.
          </p>
        </div>
      </div>
      <div className="bg-blue-100 p-6 rounded-xl text-center mb-10" data-id="element-69">
        <p className="text-gray-700 mb-6" data-id="element-70">
          <strong data-id="element-71">
            Other golfers are spending $300+ buying separate training aids for
            shallowing, alignment, wedge work, and swing path. The Blue Brick
            replaces all of them – and unlike those other devices, it's
            calibrated with actual PGA Tour data, not guesswork.
          </strong>
        </p>
        <p className="text-gray-700 mb-2" data-id="element-72">
          Regular Price: <span className="line-through" data-id="element-73">$169</span>
        </p>
        <p className="text-2xl font-bold text-red-600 mb-2 relative" data-id="element-74">
          Your Price: Only $129 USD
          <svg className="absolute -bottom-2 left-0 w-full" height="8" viewBox="0 0 200 8" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-75">
            <path d="M1 5.5C47.5 2.5 146.5 2.5 199 5.5" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" data-id="element-76" />
          </svg>
        </p>
      </div>
      <p className="text-xl font-medium text-center text-gray-800" data-id="element-77">
        Ready to finally fix your swing? The Blue Brick is selling fast – secure
        yours today and start hitting it like you always knew you could.
      </p>
    </div>;
}